<app-nav-header class="header-nav"></app-nav-header>
    <router-outlet class="pages-content"></router-outlet>
<app-footer></app-footer>
